<template>
    <div class="login-wrapper relative" id="register-avatar">
        <div class="container">
            <div class="row logo-row justify-content-center">
                <div class="col-md-4">
                    <!--<img src="../../assets/img/apostle_logo.png" class="width-100 relative" />-->
                </div>
            </div>
            <div class="row form-row">
                <div class="col-md-12">
                    <Card contentSpacing="none">
                        <div class="row row-eq-height">
                            <div class="col-md-6 login-illustration d-none d-md-block">
                                <div class="login-side">
                                    <div class="flex-content">
                                        <div class="row justify-content-center">
                                            <div class="col-md-6 text-center">
                                                <img src="@/assets/img/login-img-1.png" class="width-100 relative" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="login-side break-after">
                                    <div class="form-branding"><img src="@/assets/img/apostle_logo.png" class="width-100 relative" /></div>
                                    <div class="login-intro">
                                        <h2>Which themes are you interested in?</h2>
                                    </div>
                                    <div class="login-intro">
                                        <h2>You're almost there 🎉</h2>
                                        <p>Lastly, choose a picture for your avatar</p>
                                    </div>
                                    <form>
                                        <Input type="avatar" class="avatar-input" width="inline">LH</Input>
                                        <div class="width-100 relative">
                                            <router-link to="../../register/choose-themes"><Button class="float-left" variant="neutral">Previous</Button></router-link>
                                            <router-link to="../../dashboard"><Button class="float-right">Finish</Button></router-link>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </Card>
                    <div class="width-100 relative text-center m-t-md">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Input from "../../../components/Input/Input"
    import Card from "../../../components/Card/Card"
    import Button from "../../../components/Button/Button"

    export default {
        name: 'RegisterAvatar',
        components: {
            Input,
            Card,
            Button
        },
        props: [],
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./RegisterAvatar.scss" scoped lang="scss"></style>

